// extracted by mini-css-extract-plugin
export default {"tabs":"tabs-NnzMI","tabs__container":"tabs__container-Cn8cX","c-input__inputbox":"c-input__inputbox-sOJ3n"};